import { ref, onMounted, watch, provide } from "vue"
import validateToken from "../services/validateToken"
import { useRoute } from "vue-router"

export default function useAuthentication() {
  const authenticated = ref(null)
  provide("authenticated", authenticated)

  const route = useRoute()

  const setAuthenticatedAfterNavigation = async () => {
    const token = localStorage.getItem("access-token")
    /* No need to check token validity here. If a token exists here it's valid
    because it was just set prior to navigating to a new page by vue-router. */
    authenticated.value = token !== null
  }

  watch(route, setAuthenticatedAfterNavigation)

  /* Set authentication status when app mounts */
  onMounted(async () => {
    authenticated.value = await validateToken()
  })

  return { authenticated }
}
